<template>
  <div class="myOrder">
    <van-nav-bar title="我的订单" left-arrow @click-left="reBack" />
    <van-tabs v-model="active">
      <van-tab title="全部">
        <orderList v-if="active == 0" :orderStyle="0" :active="active" />
      </van-tab>
      <van-tab title="待支付">
        <orderList v-if="active == 1" :orderStyle="10" :active="active" />
      </van-tab>
      <van-tab title="预订待处理">
        <orderList v-if="active == 2" :orderStyle="25" :active="active" />
      </van-tab>
      <van-tab title="已完成">
        <orderList v-if="active == 3" :orderStyle="40" :active="active" />
      </van-tab>
      <van-tab title="退订中">
        <orderList v-if="active == 4" :orderStyle="20" :active="active" />
      </van-tab>
      <van-tab title="已退订">
        <orderList v-if="active == 5" :orderStyle="30" :active="active" />
      </van-tab>
      <van-tab title="已关闭">
        <orderList v-if="active == 6" :orderStyle="-10" :active="active" />
      </van-tab>
    </van-tabs>
    <div class="footer">
      <Footer active="myOrder"></Footer>
    </div>
  </div>
</template>

<script>
import "@/assets/hotel/css/reset.css";
import navBar from "../components/navBar";
import orderList from "./orderList.vue";
import Footer from "@/pages/hotel/components/footer-nav.vue";
export default {
  data() {
    return {
      isiOSX: false,
      active: 0,
    };
  },
  components: {
    orderList,
    navBar,
    Footer,
  },
  created() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active);
    }
    this.isiOSX = this.isIphoneX();
    sessionStorage.isiOSX = this.isiOSX;
    
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  methods: {
    reBack() {
      // if(this.$route.query.hotel_detail){
      //   this.$router.go(-3);
      // }else{
      //   this.$router.go(-1);
      // }
      this.$router.push({
        path: "/hotel/home",
      });
    },
  },
};
</script>
<style lang="less">
.myOrder {
  .van-tab--active {
  color: #333333 !important;
  font-size: 2rem !important;
  font-weight: 600 !important;
}
  .van-tabs__line {
    background-color: #108b30;
    width: 1.2rem !important;
    top: 3.6rem;
    position: absolute;
    z-index: 1;
    height: 0.3rem;
    border-radius: 0.3rem;
  }
  .van-tabs__wrap--scrollable {
    box-shadow: 0px 5px 10px 0px rgba(19, 19, 19, 0.1);
    position: relative;
    z-index: 21;
  }
  .van-tab {
  font-size: 1.6rem;
  color: #666666;
  font-weight: 400;
}
 .van-nav-bar {
  // background: rgba(255, 255, 255, 0);
  padding-top: 4.4rem;
  // position: fixed;
  // top: 0;
  // width: 100%;
  // background: #fff;
} 
.van-nav-bar__content{
  height: 3.9rem;
}
.van-nav-bar__title {
  font-size: 1.6rem;
  color: #333;
  font-weight: 600;
}
}
</style>
<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon {
  color: #333;
  font-size: 1.8rem;
}
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.myOrder {
  background-color: #ffffff;
  height: calc(100% - 44px);
  overflow: hidden;
  /* overflow-y: hidden; 解决上拉刷新容器会在开始时自身可以滚动 */
}



.van-icon-arrow-left:before {
  display: none;
}
.van-nav-bar__left {
  left: 0;
  padding-left: 1.6rem;
}
.van-nav-bar__left .van-icon {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  background: url(../../../assets/myInvest/reback.png) no-repeat center center;
  background-size: 100% 100%;
}
.van-nav-bar__text {
  width: 8.1rem;
  height: 2.8rem;
  line-height: 2.8rem;
  color: #fff;
  font-size: 1.4rem;
  text-align: center;
  background: rgba(29, 30, 31, 0.2);
  border-top-left-radius: 1.4rem;
  border-bottom-left-radius: 1.4rem;
  padding: 0;
}
/* // .myOrder >>> [class*="van-hairline"]::after {
//   border: none;
// } */
.van-tabs {
  height: 100%;
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0; */
}
.van-hairline--bottom:after {
  border: none;
}
.van-tab {
  line-height: 2rem;
}


.van-tabs__content {
  height: 100%;
}
.van-tab__pane {
  overflow: scroll;
  height: calc(100vh - 132px) !important;
}


.van-sticky {
  position: fixed;
  top: 8.8rem;
  width: 100%;
  z-index: 2;
  border-bottom: solid 1px #eeeeee;
  box-shadow: 0 1.1rem 1.1rem -0.1rem #e8e8e8;
}
.van-tab__pane {
  height: 100%;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 999;
}
</style>
